import { Payment_Data } from './basket';
import {
    Allergy,
    family_history,
    Medication,
    past_medical_history_data
} from './history';
import { Prescription } from './prescription';
import { ApiResult } from './PromiseResult';
import { reportspdf } from './reportspdf';
import { InvoicePrint } from './transactions';
import { PaginationModel, TabView_Data } from './util.models';

export class Patients {
    sr_no: number;
    patient_guid: string;
    consultation_id: number;
    name: string;
    age: string;
    address?: string;
    country?: string;
    contact?: string;
    specialty?: string[];
    opinion_type: string;
    priority_type?: string;
    doctor_name?: string[];
    email?: string;
    consultation_date: Date;
    req_no: string;
}

export class raw_patient {
    patient_guid: string;
    id: number;
    consultation_date: Date;
    consultation_request_number: string;
    accounts: {
        first_name: string;
        middle_name: string;
        last_name: string;
        date_of_birth?: Date;
        address_line_1?: string;
        address_line_2?: string;
        primary_contact_number?: string;
        country: {
            country_name: string;
        };
        user_patient?: {
            user_guid: string;
            users: {
                e_email: string;
            };
        };
    };
    p_consultation_appointment: {
        specialty_id: number;
        user_guid: string;
        d_specialty_type: {
            specialty_name: string;
        };
        egd_users?: {
            d_email: string;
            first_name: string;
            middle_name: string;
            last_name: string;
        };
    }[];
    priority_type: {
        consultation_name: string;
        priority_type: string;
        transaction_type: string;
    };
}

export class PatientProfile {
    patient: {
        first_name: string;
        middle_name: string;
        last_name: string;
        gender: string;
        date_of_birth: Date;
        address_line_1: string;
        address_line_2: string;
        city: string;
        state_name: string;
        primary_contact_number: string;
        secondary_contact_number: string;
        avatar_url: string;
        medical_record_number: string;
        identification_type: string;
        identification_url: string;
        valid_till_Date: Date;
        created_at: Date;
        country: {
            country_name: string;
        };
    };
    documents: {};
    allergies_medications: {
        medications_allergies_data: {
            allergies: Allergy[];
            medications: Medication[];
        };
    };
    history: {
        past_medical_history_data: past_medical_history_data[];
        past_surgical_history_data: string;
        social_history: {
            smoking: {
                selected: string;
                data: {};
            };
            alcohol: {
                selected: string;
                data: {};
            };
        };
        family_history: family_history[];
    };
    condtion: {
        id: number;
        current_medical_problems: string;
    };
    consultation?: {
        consultations: patient_consultation[];
        condition_description: any;
    };
}

export class patient_consultation {
    consultation_request_number: string;
    id: number;
    consultation_date: Date;
    consultation_status: string;
    created_at: Date;
    consultation_type: {
        consultation_name: string;
    };
    priority_type: {
        consultation_name: string;
        priority_type: string;
    };
    communication_type: {
        communication_name: string;
    };
    p_consultation_appointment: {
        specialty_id: number;
        user_guid: string;
        d_specialty_type: {
            specialty_name: string;
        };
        egd_users?: {
            d_email: string;
            first_name: string;
            middle_name: string;
            last_name: string;
        };
    }[];
    p_prescriptions: Prescription[];
}

export class consultation_table_model {
    sr_no: number;
    consultation_date: Date;
    specialty_name: string[];
    priority_type: string;
    doctor_name: string[];
    doctor_report: string;
    prescriptions: Prescription[];
    consultation_id: number;
    consultation_status: string;
}

export class PatientProfileQuery {
    patient_guid: string;
    consultation_id?: number;
    token?: string;
    user_guid?: string;
}

export class GenrateToken {
    user_guid: string;
    valid_till: Date;
    patient_guid: string;
}

export class GetMyPatientsQuery extends PaginationModel {
    user_guid?: string;
    country_id: number;
    from_date: Date;
    to_date: Date;
    consultation_type_id?: number;
    specialty_id?: number;
    returnCount: boolean;
    first: number;
}

export class PastConsultationDataInput {
    patient_guid: string;
    consultation_id: number;
}

export class ReportsPrescriptionData {
    display: boolean;
    show: string;
    printcontent: string;
    posting: boolean;
    data: {
        input: PastConsultationDataInput;
        apiData: ApiResult;
        data: reportspdf;
    };
}

export class PastConsultationData {
    past_consultation: {
        data: {
            input: PastConsultationDataInput;
            apiData: ApiResult;
            consultation_data: consultation_table_model[];
        };
    };
    reports: ReportsPrescriptionData;
    prescription: ReportsPrescriptionData;
}

export class health_passport_storage {
    max_storage_space: number = 0;
    storage_space_used: number = 0;
    valid_till: Date = null;
    percentage: number = 0;
    days_left: number = 0;
    formattedMaxStorageSpace: string;
    formattedStorageSpaceUsed: string;
}

export class health_passport_priority {
    id: number;
    transaction_type: string;
    consultation_name: string;
    priority_type: string;
    specialty_id: number;
    amount: number;
    consultation_type_id: number;
    response_min: number;
    response_max: number;
    description: string;
    is_onetime: boolean;
    number_of_consultations: number;
    image_url: string;
    storage_space: number;
    country: {
        currency_type: string;
    };
}

export class create_health_passport_body {
    patient_guid: string;
    priority_type_id: number;
}

export class healthPassportData {
    create_passport: create_health_passport_body =
        new create_health_passport_body();
    tabview_Data: TabView_Data = new TabView_Data(0, 1);
    paymentData: Payment_Data = new Payment_Data();
    print_data: InvoicePrint = new InvoicePrint();
    health_passport_submit_api_result: ApiResult = new ApiResult(false);
    health_passport_list_api_result: ApiResult = new ApiResult(false);
    constructor(min_tab: number, max_tab: number) {
        this.tabview_Data = new TabView_Data(min_tab, max_tab);
    }
}
